import { useState } from "react";
import { useTranslations } from "next-intl";

export type CloneReport = {
  attachmentsCopied: number;
  attachmentsNotCopied: string[];
  localVideosNotCopied: string[];
};

export function isCloneReport(value: unknown): value is CloneReport {
  const v = value as CloneReport | null;
  return (
    !!v &&
    typeof v.attachmentsCopied === "number" &&
    Array.isArray(v.attachmentsNotCopied) &&
    Array.isArray(v.localVideosNotCopied)
  );
}

/** CRS-6: after a clone, say what was copied and what must be uploaded again. */
export function CloneReportNotice({ report }: { report: CloneReport }) {
  const t = useTranslations("instructor");
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div
      role="status"
      data-testid="clone-report"
      className="rounded-lg border border-[var(--border)] bg-[var(--surface-2)] p-4 text-sm"
    >
      <p className="font-medium">{t("cloneReportTitle")}</p>
      <p className="mt-1">{t("cloneReportPdfs", { count: report.attachmentsCopied })}</p>
      {report.attachmentsNotCopied.length > 0 ? (
        <p className="mt-1 text-[var(--danger)]" data-testid="clone-report-pdfs-missing">
          {t("cloneReportPdfsMissing", { names: report.attachmentsNotCopied.join(", ") })}
        </p>
      ) : null}
      {report.localVideosNotCopied.length > 0 ? (
        <p className="mt-1 text-[var(--danger)]" data-testid="clone-report-videos">
          {t("cloneReportVideos", { names: report.localVideosNotCopied.join(", ") })}
        </p>
      ) : null}
      <button type="button" className="mt-2 underline" onClick={() => setOpen(false)}>
        {t("cloneReportDismiss")}
      </button>
    </div>
  );
}
